import React, { useEffect, useState } from 'react';
import { ReactComponent as EventIcon } from 'assets/icons/event-icon.svg';
import { ReactComponent as GiftIcon } from 'assets/icons/gift-icon.svg';
import { ReactComponent as HelpIcon } from 'assets/icons/help-icon.svg';
import useDashboardContext from 'contexts/dashboard.context';
import BusinessCard from 'components/business-card';
import GiftAMemberModal from 'components/modals/gift-a-member-modal';
import FundWalletModal from 'components/modals/fund-wallet-modal';
import PageHeader from 'components/base/page-header';
import { ROUTE_KEYS, STORAGE_KEYS } from 'utils/constants';
import Slider from 'react-slick';
import HomeSlide from './home-slide';
import LearnMoreModal from 'components/modals/learn-more-modal';
import './styles.scss';

const Home = () => {
  const lastName = localStorage.getItem(STORAGE_KEYS.LAST_NAME);
  const { members, setIsBackLink } = useDashboardContext();
  const [showGiftMemberModal, setShowGiftMemberModal] = useState(false);
  const [showFundWalletModal, setShowFundWalletModal] = useState(false);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    setIsBackLink(false);
  }, []);

  const businessItems = [
    {
      icon: <EventIcon />,
      title: 'Host an event',
      description:
        'Plan and organize memorable company events effortlessly. Set budgets, invite team members, manage RSVPs and expenses...',
      link: '/event-details'
    },
    {
      icon: <GiftIcon className='text-[#E60A2B]' />,
      title: 'Gift a member',
      description:
        'Show your appreciation to employees on their special days. Choose from a selection of thoughtful gifts and make their day brighter',
      link: '',
      onclick: () => setShowGiftMemberModal(true),
      disabled: !members?.length
    },

    {
      icon: <HelpIcon />,
      title: 'Get Support',
      description:
        'Need assistance or have questions? Our support team is here to guide you through every step. Contact us for any inquiries...',
      link: `/${ROUTE_KEYS.SUPPORT}`
    }
  ];
  const settings = {
    speed: 100,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    dots: true,
    swipe: true,
    draggable: true
  };
  return (
    <div className='w-full'>
      <PageHeader
        title={`Welcome ${lastName} 👋🏼`}
        subtitle='We’re here to help you get things rolling'
      />
      <div className='w-full'>
        <Slider {...settings}>
          <div>
            <HomeSlide setShowModal={setShowModal} />
          </div>
          <div>
            <HomeSlide setShowModal={setShowModal} />
          </div>
          <div>
            <HomeSlide setShowModal={setShowModal} />
          </div>
        </Slider>
      </div>

      <div className='w-full mt-6'>
        <p className='text-lg font-medium pt-2 mb-6'>Do more with Foodcourt business🚀</p>

        <div className='flex flex-wrap justify-between gap-6'>
          {businessItems.map((item, index) => {
            return (
              <div key={index} className='w-full sm:w-[48%]'>
                <BusinessCard item={item} />
              </div>
            );
          })}
        </div>

        <GiftAMemberModal
          isOpen={showGiftMemberModal}
          onClose={() => setShowGiftMemberModal(false)}
          setShowFundWalletModal={setShowFundWalletModal}
        />
        <FundWalletModal
          isOpen={showFundWalletModal}
          onClose={() => setShowFundWalletModal(false)}
        />
        <LearnMoreModal show={showModal} onClose={() => setShowModal(false)} />
      </div>
    </div>
  );
};

export default Home;
